<template>
  <main class="main page-inside page-not-found payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <img src="./../img/hero.jpg" class="bg"/>
        <div class="wrapper home">
          <div class="title big">404</div>
        </div>
      </div>
      <section class="section store-section">
        <img src="./../img/section6.svg" class="bg"/>
        <div class="wrapper">
        </div>
      </section>
    </div>
  </main>
</template>
<script>

export default {
  name: 'PageNotFound',
  props: [],
  components: {
  },
  data: function() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>